/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_Never_PrintedInputs */



/**
* | output |
* | --- |
* | "This card was never printed" |
*
* @param {Error_Notfound_Heading_Never_PrintedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_never_printed = /** @type {((inputs?: Error_Notfound_Heading_Never_PrintedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_Never_PrintedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Karte wurde nie gedruckt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette carte n'a jamais été imprimée")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这张卡从未印制过")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這張卡從未印製過")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이 카드는 인쇄된 적이 없습니다")
	return /** @type {LocalizedString} */ ("This card was never printed")
});